import Axios from "axios";

const general = {
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json'
  }
};

const AxiosDefault = Axios.create(general);

const AxiosImage = Axios.create({
  ...general,
  responseType: 'blob'
});

export { AxiosDefault, AxiosImage }
